import React, { useEffect, useRef, useState } from 'react'
import GamePlay from '../GamePlay'
import LevelSelection from '../LevelSelection'
import {GAME_OVER, GAME_WON} from '../../constants/webView_comm_messages'
import { useStateHooks } from '../../state/provider'
import { View } from 'react-native'
import ConfettiCannon from 'react-native-confetti-cannon'

export default function ScreenManager() {
  const tId = useRef();
  const [screen, setScreen] = useState('LEVEL_SELECTION')
  const [selectedLevel, setSelectedLevel] = useState();
  const levelSelectionHandler = idx => {
    setSelectedLevel(idx)
    setScreen('GAME_PLAY');
  }
  const { state: {
    overlay,
    currentLevel,
    latestArenaResult,
    showEnding,
    arenas = [],
  }, ...actions } = useStateHooks().app
  
  useEffect(() => {
    window.ReactNativeWebView = {
      postMessage: (msgKey) => {
        const [eventName, value] = msgKey.split(':')
        switch(eventName) {
          case GAME_OVER:
            actions.setArenaResult(selectedLevel, Number(value))
            setTimeout(() => window.location.reload(), 2000)
            break
          case GAME_WON:
            const totalCompleted = arenas.reduce((t, a) => {
              return a.result === 1 ? t + 1 : t
            }, 0)
            const isGameCompleted = totalCompleted === arenas.length - 1 && arenas[selectedLevel].result !== 1;
            actions.setArenaResult(selectedLevel, 1)
            if (isGameCompleted) {
              actions.setShowEnding(true)
            }
            // setScreen('LEVEL_SELECTION');
            setTimeout(() => window.location.reload(), 2000)
            break
        }
      }
    };
  }, [selectedLevel, arenas])
  useEffect(() => {
    if (showEnding && screen === 'LEVEL_SELECTION') {
      tId.current = setTimeout(() => {
        actions.setShowEnding(false)
      }, 15000);
    }
    () => {
      clearTimeout(tId.current)
    }
  }, [showEnding])
  return (
    <View style={{ flexBasis: '100%', width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center',
      backgroundColor: screen === 'GAME_PLAY' ? '#171717' : '#171717'
    }}>
      <View style={{ maxWidth: 900, maxHeight: 400, width: '100%', height: '100%', backgroundColor: '#f0f0f0', margin: 'auto'}}>
        {screen === 'HOME' && <Home onPlay={() => true} onRestart={() => true} />}
        {screen === 'LEVEL_SELECTION' && <LevelSelection onSelect={levelSelectionHandler}/>}
        {screen === 'GAME_PLAY' && <GamePlay currentLevel={selectedLevel} />}
      </View>
      {showEnding && screen === 'LEVEL_SELECTION' && <ConfettiCannon count={200} origin={{x: -10, y: 0}} />}
    </View>
  )
}